<div class="container-table">
  <mat-table
    [class.isMobile]="true"
    #table
    class="table table-p1 borderless align-middle"
    matSortDisableClear
    [dataSource]="dataSource"
    matSort
    matSortDirection="desc"
  >
    <ng-container matColumnDef="senderReceiverName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Nome</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Nome:</span>

        <span class="size-row">
          {{ row.senderReceiverName }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="country">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">País</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">País:</span>

        <span class="label-desktop label-data">
          {{ row.country.description }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="currencyContact">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Moeda</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Moeda:</span>

        <span class="label-desktop label-data">
          <mat-icon [svgIcon]="getCurrencyIcon(row.currency)"></mat-icon>
          <span class="ml-2">{{ getCurrencyDescription(row.currency) }}</span>
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="type">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Tipo de contato</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Tipo de contato:</span>

        <span
          *ngIf="row?.type == 'SenderAccount'"
          class="label-desktop label-data"
        >
          Pagador
        </span>

        <span
          *ngIf="row?.type == 'ReceiverAccount'"
          class="label-desktop label-data"
        >
          Beneficiário
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="action">
      <mat-header-cell *matHeaderCellDef>
        <p class="label-desktop">Ações</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Ações:</span>

        <div class="d-flex align-items-center gap-2">
          <span class="open-details-text" (click)="openContactDetails(row)"
            >Ver</span
          >

          <mat-icon [matMenuTriggerFor]="beforeMenu" class="more-options"
            >more_vert</mat-icon
          >
          <mat-menu class="my-menu" #beforeMenu="matMenu" xPosition="before">
            <button
              mat-menu-item
              class="custom-button"
              (click)="openAddContactModal({ contact: row, isEdit: true })"
            >
              <div class="edit-icon-and-image">
                <img src="assets/icons/edit-icon.svg" />
                <span> Editar </span>
              </div>
            </button>
            <button
              mat-menu-item
              class="custom-button"
              (click)="openRemoveContactModal(row?.id)"
            >
              <div class="remove-icon-and-image">
                <img src="assets/icons/trash-icon.svg" />
                <span> Remover </span>
              </div>
            </button>
          </mat-menu>
        </div>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; let i = index; columns: displayedColumns">
    </mat-row>
  </mat-table>
</div>

<mat-paginator
  class="custom-paginator"
  [pageIndex]="pageNumber"
  [pageSize]="pageSize"
  (page)="onPageChange($event)"
  [pageSizeOptions]="[5, 10, 25, 50]"
  showFirstLastButtons
></mat-paginator>
